import { DOMAIN_HOST_BY_LOCALES } from 'config';
import { LOCALE } from 'helpers/i18n';

export const getDomain = () => DOMAIN_HOST_BY_LOCALES[LOCALE];
export const getMetaOrigin = () => `https://www.${getDomain()}`;
